require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-layoff-to-rewarding-career-in-cybersecurity.json") })
        }
      }, "path---blog-layoff-to-rewarding-career-in-cybersecurity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-layoff-to-rewarding-career-in-cybersecurity!./.cache/json/blog-layoff-to-rewarding-career-in-cybersecurity.json
// module id = 910
// module chunks = 231608221292675